module.exports = __webpack_public_path__ + "static/img/munich-university-of-applied-sciences.1a39568.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners/munich-university-of-applied-sciences.jpg
// module id = 6A06
// module chunks = 1